import React, {Component} from "react";
import {Button, Drawer, Form} from "antd";
import Select from "react-select";
import Swal from "sweetalert2";

class AddInventaris extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            inventaris_name : '',
            borrow_date: '',
            loading: false,
            inventaris_loading: false,
            inventaris_selected: null,
            inventaris_id: 0,
        }
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            currentPage: 0,
            [name]: value
        })
    }

    loadDataInventaris() {
        let form ={}
        this.props.request('inventaris/list', form, "POST")
        .then(response => {
            if (response.success) {
                this.setState({
                    data: response.data.data,
                })
            }
        })
    }

    handleSubmit = () => {
        let form = {
            karyawan: this.props.id,
            inventaris_id: this.state.inventaris_id,
            borrow_date: this.state.borrow_date,
        }
        this.props.request('inventaris/add-borrowing-v2', form, "POST")
        .then(response => {
            if (response.success) {
                this.setState({
                    inventaris_id: 0,
                    borrow_date: '',
                    inventaris_selected: null,
                })
                this.props.changeState({
                    add_visible: false,
                    data: [],
                    loading: true,
                }, () => {
                    this.props.loadData()
                })
                Swal.fire({
                    title: 'Berhasil!',
                    text: response.message,
                    icon: 'success'
                })
            } else {
                Swal.fire({
                    title: 'Gagal!',
                    text: response.message,
                    icon: 'warning',
                    confirmButtonText: 'OK'
                })
            }
            this.setState({
                loading: false,

            })
        })
    }

    componentDidMount() {
        this.loadDataInventaris();
    }

    render() {
        return (
            <Drawer title="Pinjam Inventaris" width={300} onClose={() => {
                this.props.changeState({ add_visible: false, inventaris_name : '', inventaris_id: 0, borrow_date: '', inventaris_selected: null});
            }} visible={this.props.add_visible}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
                <div style={{
                    textAlign: 'right',
                }}>
                    <Button onClick={() => {
                        this.props.changeState({ add_visible: false, inventaris_name : '', inventaris_id: 0, borrow_date: '', inventaris_selected: null });
                    }}
                            style={{ marginRight: 8 }}>
                        Batal
                    </Button>
                    <Button onClick={this.handleSubmit} disabled={this.state.loading} type="primary">
                        {this.state.loading ?
                            <><i className={"fa fa-refresh fa-spin"}></i> Loading</>
                            :
                            "Simpan"
                        }
                    </Button>
                </div>
            }>
                <Form layout="vertical" hideRequiredMark>
                    <div className="form-group">
                        <label>Nama Inventaris</label>
                        <Select
                            placeholder="Nama Inventaris"
                            backspaceRemoves={true} deleteRemoves={true}
                            styles={{paddingLeft: "0px", fontSize: '12px'}}
                            components={{
                                DropdownIndicator: () => null,
                                IndicatorSeparator: () => null
                            }}
                            value={this.state.inventaris_selected}
                            isLoading={this.state.inventaris_loading}
                            options={
                                this.state.data != null ? (
                                        this.state.data.map((item, index) => (
                                            {
                                                key: index,
                                                value: item.inventaris_id,
                                                label: item.inventaris_name,
                                            }
                                        ))
                                    )
                                    : (" ")
                            }
                            onChange={
                                (inventaris_selected) => {
                                    if (!inventaris_selected) {
                                        this.setState({
                                            inventaris_selected: '',
                                            inventaris_id: 0,
                                        })
                                    } else {
                                        this.setState({
                                            inventaris_selected,
                                            inventaris_id: inventaris_selected.value,
                                            inventaris_name: inventaris_selected.label
                                        })
                                    }
                                }
                            }
                        />
                    </div>
                    <div className="form-group">
                        <label>Tanggal Peminjaman</label>
                        <input type="date" className="form-control" name="borrow_date" onChange={this.handleChange} value={this.state.borrow_date}/>
                    </div>
                </Form>
            </Drawer>
        )
    }

}

export default AddInventaris;